import { Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { useQuantityFormat } from '../../../hooks/use-quantity-format';
import { ColumnComponentProps } from '../../../types/activity-column-types';

export function ProcessedQuantityColumn({
  info,
}: ColumnComponentProps<BackofficeActivitiesOrderItem, number | null | undefined>) {
  const { quantity } = useQuantityFormat(info.row.original, Number(info.getValue()));

  return <Text fontSize="sm" fontWeight="400">{quantity}</Text>;
}
